import { Cookie } from '@vue-util/cookie';

export default function getCSLCookie() {
  const bopsPickupStore = Cookie.get('BOPSPICKUPSTORE', 'MISCGCs');
  const cslCookie = Cookie.get('CSL') || bopsPickupStore;
  /* istanbul ignore else */
  if (Number.isNaN(Number(cslCookie))) {
    return Cookie.get('CSL');
  }
  return cslCookie;
}
